declare namespace $ {

	export class $shm_dashboard_admin_user_dashboards_follower extends $mol_follower {
	}
	
}

//# sourceMappingURL=follower.view.tree.d.ts.map